// import React, { useState } from "react";
// import { Modal, Button, Form } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";

// const SearchModal = ({ show, handleClose }) => {
//   const [searchTerm, setSearchTerm] = useState("");

//   const featureKeywords = ["Dresses", "Dresses women", "Dresses midi", "Dress summer"];
//   const recentlyViewed = [
//     { id: 1, image: "https://via.placeholder.com/200x250", title: "V-neck T-shirt" },
//     { id: 2, image: "https://via.placeholder.com/200x250", title: "Sunglasses", discount: "-25%" },
//     { id: 3, image: "https://via.placeholder.com/200x250", title: "Orange Shirt", discount: "-25%" },
//     { id: 4, image: "https://via.placeholder.com/200x250", title: "Sleeveless Top" },
//   ];

//   return (
//     <Modal show={show} onHide={handleClose} size="lg" centered>
//       <Modal.Body>
//         {/* Search Bar */}
//         <div className="d-flex justify-content-between align-items-center mb-3">
//           <Form.Control
//             type="text"
//             placeholder="Search..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="me-2"
//           />
//           <Button variant="outline-secondary" onClick={handleClose}>
//             ✕
//           </Button>
//         </div>

//         {/* Feature Keywords */}
//         <h5 className="mb-2">Feature keywords Today</h5>
//         <div className="mb-4">
//           {featureKeywords.map((keyword, index) => (
//             <Button
//               key={index}
//               variant="outline-dark"
//               size="sm"
//               className="me-2 mb-2 rounded-pill"
//             >
//               {keyword}
//             </Button>
//           ))}
//         </div>

//         {/* Recently Viewed Products */}
//         <h5 className="mb-3">Recently viewed products</h5>
//         <div className="row">
//           {recentlyViewed.map((product) => (
//             <div className="col-6 col-md-3 mb-3" key={product.id}>
//               <div className="card border-0">
//                 <div className="position-relative">
//                   {product.discount && (
//                     <span className="badge bg-danger position-absolute top-0 start-0 m-2">
//                       {product.discount}
//                     </span>
//                   )}
//                   <img
//                     src={product.image}
//                     alt={product.title}
//                     className="card-img-top rounded"
//                   />
//                 </div>
//                 <div className="card-body text-center p-2">
//                   <p className="small mb-0">{product.title}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default SearchModal;
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import mainlogo from "../../Images/vantaralogo.png";

const SearchModal = ({ show, handleClose }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const featureKeywords = [
    "Handicrafts",
    "Spices",
    "Giftings",
    "Wayanad Specials",
  ];

  // Fetch products when searchTerm changes
  useEffect(() => {
    if (!searchTerm) {
      setSearchResults([]);
      return;
    }

    const fetchProducts = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `https://vantara.datacubeglobal.com/api/api-products`,
          { params: { keyword: searchTerm } }
        );

        if (res.data.status === "success") {
          const mapped = res.data.data.map((p) => ({
            id: p.product_id,
            title: p.product_name,
            image: `${p.image_path}/${p.primary_image}`,
            price: parseFloat(p.special_price || p.mrp || 0),
            stock: p.stock,
          }));
          setSearchResults(mapped);
        }
      } catch (err) {
        console.error("Error fetching search results:", err);
      } finally {
        setLoading(false);
      }
    };

    const debounce = setTimeout(fetchProducts, 500); // debounce to avoid too many requests
    return () => clearTimeout(debounce);
  }, [searchTerm]);
const navigate=useNavigate()
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        {/* Search Bar */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Form.Control
            // type="text"
            placeholder="Search products..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="me-2"
          />
          <Button variant="outline-secondary" onClick={handleClose}>
            ✕
          </Button>
        </div>

        {/* Feature Keywords */}
        <h5 className="mb-2">Feature keywords Today</h5>
        <div className="mb-4">
          {featureKeywords.map((keyword, index) => (
            <Button
              key={index}
              variant="outline-dark"
              size="sm"
              className="me-2 mb-2 rounded-pill"
              onClick={() => setSearchTerm(keyword)}
            >
              {keyword}
            </Button>
          ))}
        </div>

        {/* Search Results */}
        <h5 className="mb-3">Search Results</h5>
        {loading ? (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{
      width: "100%",
      height: "300px", // fixed height so logo is visible
      position: "relative",
    }}
  >
    <img
      src={mainlogo}
      alt="Loading..."
      style={{
        width: "180px",
        height: "auto",
        animation: "fade 1.5s ease-in-out infinite",
      }}
    />
    <style>{`
      @keyframes fade {
        0% { opacity: 0.6; }
        50% { opacity: 1; }
        100% { opacity: 0.6; }
      }
    `}</style>
  </div>
) : searchResults.length === 0 ? (
  <p className="text-muted">No products found.</p>
) : (
          <div className="row">
            {searchResults.map((product) => (
              <div className="col-6 col-md-3 mb-3" key={product.id}>
                <div className="card border-0">
          <div className="position-relative" style={{ width: "100%", height: "200px" }}>
  {product.stock === 0 && (
    <span className="badge bg-danger position-absolute top-0 start-0 m-2">
      OUT OF STOCK
    </span>
  )}
  <img
    src={product.image}
    alt={product.title}
   onClick={() => {
            navigate(`/productDetails/${product.id}`);
            handleClose();
          }}
    className="card-img-top rounded"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
    }}
  />
</div>

                  <div className="card-body text-center p-2">
                    <p className="small mb-1">{product.title}</p>
                    <span className="fw-bold" style={{ color: "#7c0046" }}>
                      ₹{product.price.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SearchModal;
